import { Component, EventEmitter, Input, Output } from '@angular/core';

import { INameField, MultiFieldData } from '@shared/interfaces';

@Component({
  selector: 'app-section-name',
  templateUrl: './section-name.component.html',
  styleUrls: ['./section-name.component.scss'],
})
export class SectionNameComponent {
  @Input() sectionName: INameField;
  @Input() value: any; // ✅ receive customer_name value from parent
  @Output() setValue = new EventEmitter<any>();

  onComplexFieldSetClicked(_form: MultiFieldData) {
    this.setValue.emit(_form.value); // ✅ emit only value
  }
}
